import React from 'react';
import { getInitials } from '../../utilities/helpers';
import { getCardColor2 } from '../../../../../helpers/helpers';


const ModalInfoCardAlsoWorking = ({
  icon: IconComponent,
  title,
  alsoWorking,
  roleNames
}) => {

  // Function to truncate long names
  const truncateName = (name, maxLength = 16) => {
    if (name.length <= maxLength) return name;
    return name.substring(0, maxLength - 3) + '...';
  };

  return (
    <div className="rounded-lg border border-gray-200 overflow-hidden">
      {/* Header */}
      <div className="px-4 py-3 bg-gray-50 border-b border-gray-200">
        <div className="flex flex-row items-center text-gray-700">
          <IconComponent style={{ fontSize: "18px" }} />
          <span className="ml-2 text-sm font-medium">
            {title} ({alsoWorking.length})
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="px-2 py-3">
        {/* Also Working Section - Two Column Layout */}
        <div>
          <div className="flex flex-row flex-wrap">
            {alsoWorking.map((employee, index) => (
              <div
                key={index}
                className="w-1/2 pr-1 mb-2"
                style={{ width: '50%' }}
              >
                <div className="flex flex-row items-center bg-gray-50 rounded-full px-3 py-1.5">
                  {/* Avatar with initials */}
                  <div
                    className={`${getCardColor2(employee.role_id?.id, roleNames, false, false)} w-6 h-6 rounded-full flex items-center justify-center mr-1.5`}
                  >
                    <span
                      className="text-white text-xs font-medium"
                      style={{ fontSize: 10 }}
                    >
                      {employee.name !== "undefined undefined" ? getInitials(employee.name) : "O"}
                    </span>
                  </div>

                  {/* Name - Truncated if too long */}
                  <span className="text-xs font-medium text-gray-700 flex-1 truncate">
                    {employee.name !== "undefined undefined"
                      ? truncateName(employee.name)
                      : "Open Shift"}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalInfoCardAlsoWorking;
